import { Link } from 'react-router-dom';

const Chevron = () => (
  <svg
    className="w-4 h-4 text-slate-400 dark:text-slate-400 flex-shrink-0"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

const Breadcrumbs = ({ items = [], className = '' }) => {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center flex-wrap gap-1 text-sm mb-4 ${className}`}
    >
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1 min-w-0">
            {idx > 0 && <Chevron />}
            {isLast || !item.href ? (
              <span
                className={`truncate ${
                  isLast
                    ? 'text-slate-700 dark:text-slate-300 font-medium'
                    : 'text-slate-500 dark:text-slate-400'
                }`}
                aria-current={isLast ? 'page' : undefined}
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-300 hover:underline truncate"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
